// src/pages/recommandations/NouvelleRecommandation.jsx
import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../layouts/Header';
import Footer from '../../layouts/Footer';
import { COLORS } from '../../constants/colors';

// ===== STYLES =====
const styles = `
  .dashboard-styled {
    background: #f4f6f9;
    min-height: 100vh;
  }

  /* En-tête moderne */
  .header-modern {
    background: white;
    padding: 1.2rem 1.8rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    border-left: 4px solid ${COLORS.secondary};
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .header-icon-wrapper {
    width: 48px;
    height: 48px;
    background: ${COLORS.primary};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: white;
    font-size: 1.4rem;
  }

  .gradient-text {
    color: #1e293b;
    font-size: 1.3rem;
    font-weight: 700;
    margin: 0;
  }

  .badge-modern {
    background: #f1f4f9;
    color: #475569;
    padding: 0.3rem 0.8rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .badge-modern i {
    color: ${COLORS.secondary};
  }

  .btn-modern-outline {
    border: 1px solid #d1d5db;
    background: white;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: #4b5563;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .btn-modern-outline:hover {
    border-color: ${COLORS.secondary};
    color: ${COLORS.secondary};
    background: #fafafa;
  }

  .btn-modern-primary {
    background: ${COLORS.primary};
    border: none;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: white;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
  }
  .btn-modern-primary:hover {
    background: ${COLORS.primaryDark};
    box-shadow: 0 4px 10px rgba(41,90,167,0.3);
  }

  /* Card */
  .card-modern {
    border: none;
    border-radius: 4px;
    background: white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.04);
    border-top: 3px solid transparent;
    transition: box-shadow 0.2s;
  }
  .card-modern:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  }
  .card-modern.border-primary {
    border-top-color: ${COLORS.primary};
  }

  .card-header-modern {
    background: transparent;
    border-bottom: 1px solid #e9edf2;
    padding: 0.8rem 1.2rem;
    font-weight: 600;
    color: #1e293b;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .card-header-modern i {
    color: ${COLORS.secondary};
  }

  .card-body-modern {
    padding: 1.5rem;
  }

  /* Form */
  .form-label-modern {
    font-size: 0.7rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 0.2rem;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }
  .form-label-modern .required {
    color: ${COLORS.danger};
    margin-left: 2px;
  }

  .form-control-modern, .form-select-modern {
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;
    transition: all 0.2s ease;
    background: white;
  }
  .form-control-modern:focus, .form-select-modern:focus {
    border-color: ${COLORS.primary};
    box-shadow: 0 0 0 3px rgba(41,90,167,0.08);
  }
  .form-control-modern.is-invalid, .form-select-modern.is-invalid {
    border-color: ${COLORS.danger};
  }

  .form-text-modern {
    font-size: 0.7rem;
    color: #94a3b8;
    margin-top: 0.2rem;
  }

  .form-control-modern.is-invalid:focus {
    box-shadow: 0 0 0 3px rgba(239,68,68,0.08);
  }

  /* Notifications */
  .toast-notification {
    padding: 0.8rem 1rem;
    border: none;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 1.5rem;
    animation: slideDown 0.3s ease-out;
    border-radius: 4px;
  }
  .toast-notification-success {
    background: #f0fdf4;
    border-left: 3px solid ${COLORS.success};
  }
  .toast-notification-error {
    background: #fef2f2;
    border-left: 3px solid ${COLORS.danger};
  }
  .toast-icon {
    width: 28px;
    height: 28px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 1rem;
  }
  .toast-icon-success {
    background: rgba(16,185,129,0.15);
    color: ${COLORS.success};
  }
  .toast-icon-error {
    background: rgba(239,68,68,0.15);
    color: ${COLORS.danger};
  }
  .toast-content {
    flex: 1;
  }
  .toast-title {
    font-size: 0.8rem;
    font-weight: 600;
    margin-bottom: 1px;
  }
  .toast-message {
    font-size: 0.75rem;
    color: #64748b;
    margin: 0;
  }
  .toast-close {
    background: none;
    border: none;
    color: #94a3b8;
    cursor: pointer;
    padding: 2px;
    font-size: 1rem;
  }

  /* Loading */
  .loading-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
  }
  .loading-ring-wrapper {
    position: relative;
    width: 70px;
    height: 70px;
  }
  .loading-ring {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 3px solid #e9edf2;
    border-top-color: ${COLORS.primary};
    animation: spin 0.8s linear infinite;
  }
  .loading-ring-inner {
    position: absolute;
    top: 8px;
    left: 8px;
    right: 8px;
    bottom: 8px;
    border-radius: 50%;
    border: 2px solid #e9edf2;
    border-bottom-color: ${COLORS.secondary};
    animation: spin 0.6s linear infinite reverse;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .fade-in {
    animation: fadeIn 0.3s ease-out;
  }

  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-8px); }
    to { opacity: 1; transform: translateY(0); }
  }

  @media (max-width: 768px) {
    .header-modern {
      flex-direction: column;
      align-items: stretch;
      gap: 0.8rem;
      padding: 1rem;
    }
    .header-left {
      flex-wrap: wrap;
    }
  }
`;

export default function NouvelleRecommandation() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [eglises, setEglises] = useState([]);
  const [membres, setMembres] = useState([]);

  const [formData, setFormData] = useState({
    matri_membre: '',
    matri_eglise_from: '',
    matri_eglise_to: '',
    periode: '',
    description: ''
  });

  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const userStr = localStorage.getItem('user');
        if (!userStr) {
          navigate('/pages/signin2');
          return;
        }

        const user = JSON.parse(userStr);
        const userId = user.id || user.id_utilisateur;

        // Récupérer les églises
        const eglisesRes = await fetch(`https://josephsbusiness.com/api/eglises.php?user_id=${userId}&type=siege&limit=1000`);
        const eglisesData = await eglisesRes.json();
        if (eglisesData.success) {
          setEglises(eglisesData.eglises || []);
        }

        // Récupérer les membres
        const membresRes = await fetch(`https://josephsbusiness.com/api/membres.php?user_id=${userId}&limit=1000`);
        const membresData = await membresRes.json();
        if (membresData.success) {
          setMembres(membresData.membres || []);
        }

        // Si modification, charger les données
        if (id) {
          const recRes = await fetch(`https://josephsbusiness.com/api/recommandations.php?user_id=${userId}&id=${id}`);
          const recData = await recRes.json();
          if (recData.success && recData.recommandation) {
            const rec = recData.recommandation;
            setFormData({
              matri_membre: rec.matri_membre,
              matri_eglise_from: rec.matri_eglise_from,
              matri_eglise_to: rec.matri_eglise_to,
              periode: rec.periode || '',
              description: rec.description || ''
            });
          }
        }
      } catch (err) {
        setError('Erreur de chargement: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, navigate]);

  const validateForm = () => {
    const errors = {};
    if (!formData.matri_membre) errors.matri_membre = "Le membre est requis";
    if (!formData.matri_eglise_from) errors.matri_eglise_from = "L'église d'origine est requise";
    if (!formData.matri_eglise_to) errors.matri_eglise_to = "L'église de destination est requise";
    if (!formData.periode) errors.periode = "La période est requise";

    if (formData.matri_eglise_from && formData.matri_eglise_to &&
        formData.matri_eglise_from === formData.matri_eglise_to) {
      errors.matri_eglise_to = "Les églises doivent être différentes";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setSaving(true);
    setError(null);

    try {
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      const userId = user.id || user.id_utilisateur;

      const date = new Date();
      const random = Math.floor(Math.random() * 10000);
      const matricule = `REC${date.getFullYear()}${(date.getMonth()+1).toString().padStart(2,'0')}${date.getDate().toString().padStart(2,'0')}${random}`;

      const url = `https://josephsbusiness.com/api/recommandations.php?user_id=${userId}`;
      const method = id ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method: method,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          id: id,
          matricule: matricule
        })
      });

      const result = await response.json();

      if (result.success) {
        setSuccess(true);
        setTimeout(() => {
          navigate('/recommandations/liste?reload=1');
        }, 2000);
      } else {
        setError(result.message || 'Erreur lors de l\'enregistrement');
      }
    } catch (err) {
      setError('Erreur: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  const getMembreInfo = (matricule) => {
    const membre = membres.find(m => m.matricule === matricule);
    return membre ? `${membre.nom} ${membre.prenom || ''}`.trim() : null;
  };

  if (loading) {
    return (
      <>
        <Header />
        <div className="main main-app p-3 p-lg-4 dashboard-styled">
          <div className="loading-wrapper">
            <div className="text-center">
              <div className="loading-ring-wrapper mb-3">
                <div className="loading-ring"></div>
                <div className="loading-ring-inner"></div>
              </div>
              <h5 className="fw-bold" style={{ color: COLORS.primaryDark }}>Chargement...</h5>
              <p className="text-muted small">Veuillez patienter</p>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <style>{styles}</style>
      <Header />
      <div className="main main-app p-3 p-lg-4 dashboard-styled">
        <div className="container-fluid px-0">

          {/* En‑tête moderne */}
          <div className="header-modern mb-4 fade-in">
            <div className="header-left">
              <div className="header-icon-wrapper">
                <i className={id ? "ri-edit-line" : "ri-add-line"}></i>
              </div>
              <div>
                <h5 className="gradient-text">
                  {id ? 'Modifier la recommandation' : 'Nouvelle recommandation'}
                </h5>
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge-modern">
                    <i className="ri-information-line"></i>
                    {id ? 'Modification' : 'Création'}
                  </span>
                  <span className="badge-modern">
                    <i className="ri-calendar-line"></i>
                    {new Date().toLocaleDateString('fr-FR')}
                  </span>
                </div>
              </div>
            </div>
            <div className="d-flex gap-2">
              <Button size="sm" className="btn-modern-outline" onClick={() => navigate('/recommandations/liste')}>
                <i className="ri-arrow-left-line"></i> Retour
              </Button>
            </div>
          </div>

          {/* Notifications */}
          {success && (
            <div className="toast-notification toast-notification-success mb-4">
              <div className="toast-icon toast-icon-success">
                <i className="ri-checkbox-circle-line"></i>
              </div>
              <div className="toast-content">
                <div className="toast-title" style={{ color: COLORS.success }}>Succès</div>
                <p className="toast-message">Recommandation enregistrée avec succès. Redirection...</p>
              </div>
              <button className="toast-close" onClick={() => setSuccess(false)}>
                <i className="ri-close-line"></i>
              </button>
            </div>
          )}

          {error && (
            <div className="toast-notification toast-notification-error mb-4">
              <div className="toast-icon toast-icon-error">
                <i className="ri-error-warning-line"></i>
              </div>
              <div className="toast-content">
                <div className="toast-title" style={{ color: COLORS.danger }}>Erreur</div>
                <p className="toast-message">{error}</p>
              </div>
              <button className="toast-close" onClick={() => setError(null)}>
                <i className="ri-close-line"></i>
              </button>
            </div>
          )}

          {/* Formulaire */}
          <Row>
            <Col lg={8} className="mx-auto">
              <Card className="card-modern border-primary">
                <Card.Header className="card-header-modern">
                  <i className="ri-information-line"></i> Informations de la recommandation
                </Card.Header>
                <Card.Body className="card-body-modern">
                  <Form onSubmit={handleSubmit}>
                    {/* Membre */}
                    <Form.Group className="mb-4">
                      <Form.Label className="form-label-modern">
                        <i className="ri-user-line me-1"></i> Membre <span className="required">*</span>
                      </Form.Label>
                      <Form.Select
                        name="matri_membre"
                        value={formData.matri_membre}
                        onChange={handleInputChange}
                        isInvalid={!!validationErrors.matri_membre}
                        className="form-select-modern"
                      >
                        <option value="">Sélectionnez un membre</option>
                        {membres.map(membre => (
                          <option key={membre.matricule} value={membre.matricule}>
                            {membre.nom} {membre.prenom || ''} - {membre.role || 'Membre'}
                          </option>
                        ))}
                      </Form.Select>
                      {validationErrors.matri_membre && (
                        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                          {validationErrors.matri_membre}
                        </Form.Control.Feedback>
                      )}
                      {formData.matri_membre && (
                        <div className="form-text-modern mt-1">
                          <i className="ri-information-line me-1"></i>
                          {getMembreInfo(formData.matri_membre)}
                        </div>
                      )}
                    </Form.Group>

                    {/* Églises */}
                    <Row className="mb-4">
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="form-label-modern">
                            <i className="ri-building-line me-1"></i> Église d'origine <span className="required">*</span>
                          </Form.Label>
                          <Form.Select
                            name="matri_eglise_from"
                            value={formData.matri_eglise_from}
                            onChange={handleInputChange}
                            isInvalid={!!validationErrors.matri_eglise_from}
                            className="form-select-modern"
                          >
                            <option value="">Sélectionnez une église</option>
                            {eglises.map(eglise => (
                              <option key={eglise.matricule} value={eglise.matricule}>
                                {eglise.nom}
                              </option>
                            ))}
                          </Form.Select>
                          {validationErrors.matri_eglise_from && (
                            <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                              {validationErrors.matri_eglise_from}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="form-label-modern">
                            <i className="ri-building-line me-1"></i> Église de destination <span className="required">*</span>
                          </Form.Label>
                          <Form.Select
                            name="matri_eglise_to"
                            value={formData.matri_eglise_to}
                            onChange={handleInputChange}
                            isInvalid={!!validationErrors.matri_eglise_to}
                            className="form-select-modern"
                          >
                            <option value="">Sélectionnez une église</option>
                            {eglises.map(eglise => (
                              <option key={eglise.matricule} value={eglise.matricule}>
                                {eglise.nom}
                              </option>
                            ))}
                          </Form.Select>
                          {validationErrors.matri_eglise_to && (
                            <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                              {validationErrors.matri_eglise_to}
                            </Form.Control.Feedback>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    {/* Période */}
                    <Form.Group className="mb-4">
                      <Form.Label className="form-label-modern">
                        <i className="ri-calendar-line me-1"></i> Période <span className="required">*</span>
                      </Form.Label>
                      <Form.Select
                        name="periode"
                        value={formData.periode}
                        onChange={handleInputChange}
                        isInvalid={!!validationErrors.periode}
                        className="form-select-modern"
                      >
                        <option value="">Sélectionnez une période</option>
                        <option value="Janvier-Mars 2025">Janvier-Mars 2025</option>
                        <option value="Avril-Juin 2025">Avril-Juin 2025</option>
                        <option value="Juillet-Septembre 2025">Juillet-Septembre 2025</option>
                        <option value="Octobre-Décembre 2025">Octobre-Décembre 2025</option>
                        <option value="Janvier-Mars 2026">Janvier-Mars 2026</option>
                        <option value="Année 2025">Année 2025</option>
                        <option value="Année 2026">Année 2026</option>
                      </Form.Select>
                      {validationErrors.periode && (
                        <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                          {validationErrors.periode}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>

                    {/* Description */}
                    <Form.Group className="mb-4">
                      <Form.Label className="form-label-modern">
                        <i className="ri-file-text-line me-1"></i> Description (optionnelle)
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        placeholder="Ajoutez des détails sur cette recommandation..."
                        className="form-control-modern"
                      />
                    </Form.Group>

                    {/* Boutons */}
                    <div className="d-flex justify-content-end gap-3 mt-4">
                      <Button
                        variant="light"
                        onClick={() => navigate('/recommandations/liste')}
                        disabled={saving}
                        className="btn-modern-outline"
                      >
                        <i className="ri-close-line me-1"></i> Annuler
                      </Button>
                      <Button
                        type="submit"
                        disabled={saving}
                        className="btn-modern-primary"
                      >
                        {saving ? (
                          <><Spinner size="sm" className="me-1" /> Enregistrement...</>
                        ) : (
                          <><i className="ri-save-line me-1"></i> {id ? 'Modifier' : 'Enregistrer'}</>
                        )}
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Footer />
        </div>
      </div>
    </>
  );
}